import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'nameJoining' })
export class NameJoiningPipe implements PipeTransform {
    transform(names: Array<string>, separator: string = ' '): any {
        const joinedName = names.filter(_ => _).join(separator);
        return joinedName || '';
    }
}
